/**
 * Stable `error` codes from the CoreAPI error envelope.
 *
 * These are the public contract. API-layer codes are declared in
 * `code/golden_brick/src/apps/api/errors/http_errors.py`; domain codes are the
 * domain exception class names. They are matched exactly, so renaming one on
 * the backend is a breaking change for every client.
 *
 * These replaced a set of human-readable message strings. One of those,
 * 'Wrong Login Parameters', matched nothing the backend ever sent — a dead
 * branch that no test caught because the mocks reproduced the same fiction.
 */
export const API_ERROR_CODES = {
  NOT_AUTHENTICATED: 'NotAuthenticated',
  USER_LOGIN_FAILED: 'UserLoginFailed',
  USER_PROPERTY_INVALID: 'UserPropertyInvalid',
  USER_STATUS_NOT_ALLOWED: 'UserStatusNotAllowed',
  MISSING_CSRF_CODE: 'MissingCsrfCode',
  EXPIRED_CSRF_CODE: 'ExpiredCsrfCode',
  INVALID_CSRF_CODE: 'InvalidCsrfCode',
  SESSION_REVOKED: 'SessionRevoked',
  CLIENT_NOT_FOUND: 'ClientNotFound',
  INVALID_REQUEST: 'InvalidRequest',
} as const;

export type ApiErrorCode = (typeof API_ERROR_CODES)[keyof typeof API_ERROR_CODES];

export const LOGIN_CREDENTIAL_FAILURE_CODES: readonly string[] = [
  API_ERROR_CODES.USER_LOGIN_FAILED,
  API_ERROR_CODES.USER_PROPERTY_INVALID,
];
